import DOMPurify from 'dompurify'

/** Returns plain text safe for display (no HTML), optionally truncated to max length. */
export function truncatePostDescription(text: string | null | undefined, max: number = 80): string {
  if (!text) return ''
  const plain = DOMPurify.sanitize(text, { ALLOWED_TAGS: [] })
  if (plain.length <= max) return plain
  return `${plain.slice(0, max).trim()}…`
}
